import React from "react";
import { AdminHeader } from "../../../components/admin/adminHeader";
import { AppLayout, AppLayoutProps } from "../../layouts";

export const AdminLayout = (props: AppLayoutProps) => (
  <AppLayout {...props} header={<AdminHeader />} />
);
